{
  "layer_dwg": "capa como DWG",
  "layer_kml": "capa como KML",
  "drawing_units": "Unidades de dibujo",
  "coordinate_system": "Sistema de coordenadas",
  "advanced_rebase_options": "Opciones de rebase avanzadas",
  "source_latitude": "Latitud de origen",
  "source_longitude": "Longitud de origen",
  "target_x": "Objetivo X",
  "target_y": "Objetivo Y",
  "target_rotation": "Rotación del objetivo (grados)",
  "export_dwg": "Exportar DWG",
  "route_convert_line": "Convertir en línea",
  "route_convert_confirmation": {
    "title": "Convierte ruta en línea",
    "message": "¿Está seguro de que desea convertir esta ruta en una línea? Esta acción no se puede deshacer."
  },
  "styles": {
    "lineTypes": {
      "dotted": "Punteado",
      "smallDash": "Pequeños punteados",
      "largeDash": "Largos punteados"
    }
  },
  "no_copy_empty_group": "No se puede copiar: la selección no contiene capas",
  "map_group_status": {
    "title": "Agrupar capas/grupos",
    "explain": "Agrupe capas y otros grupos",
    "nested_level": "Los grupos solo pueden tener 3 niveles de profundidad",
    "parent": "Los artículos no pueden estar en grupos diferentes",
    "amount": "Seleccione al menos un elemento para habilitar la agrupación",
    "type": "La selección no debe contener objetos de mapa",
    "loading": "Espere a que el mapa termine de cargarse",
    "permissions": "Se requiere el permiso de «acceso total» al plan para habilitar la agrupación"
  },
  "map_unlink_status": {
    "title": "Desvincular capas",
    "explain": "Separa y copia las capas de su plan original",
    "amount": "Seleccione al menos una capa enlazada para permitir la desvinculación de capas",
    "type": "La selección solo debe contener capas enlazadas",
    "loading": "Espere a que el mapa termine de cargarse",
    "permissions": "Se requiere el permiso de «edición» del plan para desvincular las capas"
  },
  "copy_status": {
    "title": "Copiar capas/grupos",
    "explain": "Hace una copia de las capas y grupos seleccionados",
    "amount": "Seleccione al menos una capa para permitir la copia de capas",
    "type": "La selección solo debe contener capas y grupos",
    "loading": "Espere a que el mapa termine de cargarse",
    "permissions": "Se requiere el permiso de «edición» del plan para copiar capas y grupos"
  },
  "map_delete_status": {
    "title": "Eliminar capas o grupos",
    "explain": "Elimina las capas y los grupos seleccionados",
    "amount": "Seleccione al menos una capa o grupo para permitir la eliminación",
    "type": "La selección solo debe contener capas y grupos",
    "loading": "Espere a que el mapa termine de cargarse",
    "permissions": "Se requiere el permiso de «administrador» en las capas para eliminar capas y grupos"
  },
  "mapBackgroundError": {
    "title": "El fondo del mapa no está disponible",
    "part1": "No hemos podido cargar el",
    "part2": "fondo, así que cambiamos a uno diferente. Por favor inténtelo",
    "part3": "otra vez más tarde."
  },
  "qrCode": {
    "copySuccess": "Código QR copiado al portapapeles",
    "copyError": {
      "title": "No se pudo copiar el código QR",
      "message": "Vuelve a intentarlo o usa la opción de descarga"
    },
    "downloadSuccess": {
      "title": "Código QR descargado",
      "message": "Revisa tu carpeta de descargas"
    },
    "downloadError": {
      "title": "No se pudo descargar el código QR",
      "message": "Inténtelo de nuevo"
    }
  },
  "splitLines": {
    "title": "Línea dividida",
    "selectMapObject": "Seleccione una sola línea para dividirla",
    "lockedLayer": "No se puede dividir la línea: la capa está bloqueada",
    "linesOnly": "Solo se pueden dividir los objetos de línea",
    "fixedShapes": "No se pueden dividir líneas de formas fijas",
    "drawing": "No se pueden dividir líneas mientras se dibuja",
    "action": "Haga clic para dividir la línea",
    "confirmMessage": "¿Está seguro de que desea dividir esta línea? Esta acción no se puede deshacer.",
    "tooltipStart": "Desde el principio",
    "tooltipEnd": "Para terminar"
  }
}